import React from "react";
import RowComponentForTextContent from "./RowComponent";
import RowComponentStatus from "./RowComponentStatus";

function TaskDetails({ closeModal, task, colourBlindMode }) {
    return (
        <div>
            <div id="myModal" className="modal">
                <div className="modal-content">
                    <div className="title">
                        <p className="titleheader">Task Details</p>
                    </div>
                    <>
                        <div className="content">
                            <div className="content-container">
                                <RowComponentForTextContent
                                    label="Name"
                                    value={task.taskName}
                                    colourBlindMode={colourBlindMode}
                                />
                                <RowComponentForTextContent
                                    label="Type"
                                    value={task.taskType}
                                    colourBlindMode={colourBlindMode}
                                />
                                <RowComponentForTextContent
                                    label="Story Point"
                                    value={task.taskStoryPoint}
                                    colourBlindMode={colourBlindMode}
                                />
                                <RowComponentForTextContent
                                    label="Tag"
                                    value={task.taskTag}
                                    colourBlindMode={colourBlindMode}
                                />
                                <RowComponentForTextContent
                                    label="Priority"
                                    value={task.taskPriority}
                                    colourBlindMode={colourBlindMode}
                                />
                                <RowComponentForTextContent
                                    label="Description"
                                    value={task.taskDescription}
                                    colourBlindMode={colourBlindMode}
                                />
                                <RowComponentStatus
                                    label="Status"
                                    value={task.taskStatus}
                                />
                                <RowComponentForTextContent
                                    label="Stage"
                                    value={task.taskStage}
                                    colourBlindMode={colourBlindMode}
                                />
                                <RowComponentForTextContent
                                    label="Assignee"
                                    value={task.taskAssignee}
                                    colourBlindMode={colourBlindMode}
                                />
                            </div>
                            <span
                                className="task-details-close"
                                onClick={closeModal}
                            >
                                Close
                            </span>
                        </div>
                    </>
                </div>
            </div>
        </div>
    );
}

export default TaskDetails;
